import { render, staticRenderFns } from "./ChannelsListPage.vue?vue&type=template&id=1b0386ed&"
import script from "./ChannelsListPage.vue?vue&type=script&lang=ts&"
export * from "./ChannelsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports